import shared from './shared';

/**
* File Overview
* Normalization helper object for the body data API
*/

export default {
  normalize(data) {
    const normalizedData = { 'saddleSize': data.saddle_size };

    normalizedData.productMatches = data.recommended_saddle_families.map((obj, i) => {
      let newObj = Object.assign({}, obj);

      newObj.id = i;
      newObj.type = 'saddle';
      newObj.size = obj.saddle_size;

      newObj.description = shared.stripDescription(newObj.description);

      return newObj;
    });

    return normalizedData;
  }
}



// WEBPACK FOOTER //
// ./src/client/normalizers/saddle-data-normalizer.js